import React, { useState, useEffect, Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { isMobile } from 'react-device-detect'
import { alertActions, certboxActions } from '../../store/actions'
import Alert from '../../module/alert/Alert'
import $ from 'jquery'

class  PdfViewer extends React.Component {
	constructor(props) {
		super()
		console.log(props);
	    this.state = {
	      blobResponse: props.blobResponse,
	      crtCd: props.crtCd,
	      docid: props.docid,
	      brno: props.brno,
	      fileNm: props.fileNm,
	      fileId: props.fileId,
	      printYn: props.printYn,
	      showResponse: props.showResponse,
	      onClose: props.onClose,
	      getPrint: props.getPrint,
	      getDown: props.getDown,
	      error: props.error,
		  confirm : props.confirm,
	    }
    	this.setContentRef = (contentRef) => {
	      this.setState({
	        mountNode: contentRef?.contentWindow?.document
	      })
	    }
	}

  	componentDidMount() {
		//iframe 로드
		const pdfIfrm = $('#pdfIfrm').eq(0).document
		//console.log("load1 :: ", $('#pdfIfrm').eq(0))
		$('#pdfIfrm').on( 'load', function() {
			document.getElementById('pdfIfrm').contentWindow.document.getElementById("print").style.display ='none';
			document.getElementById('pdfIfrm').contentWindow.document.getElementById("download").style.display ='none';
			document.getElementById('pdfIfrm').contentWindow.document.getElementById("openFile").style.display ='none';
			document.getElementById('pdfIfrm').contentWindow.document.getElementById("secondaryToolbarToggle").style.display ='none';
			
		} );
  	}

	
	render() {
		
		  /**
		   * 출력
		   */
		  const print = () => {		
			this.state.confirm({
				title: '확인',
				message: '증명서 내용에 이상이 없음을 확인한 뒤 출력 하시기 바랍니다.\n (출력 후에는 단순 오타·오기인 경우에도 별도 수정 발급 절차가 필요합니다.)',
				params: {
				  type: 'confirm',
				  callback: () => {
					// 시험성적서가 한번만 출력되게 개발된 코드 주석
					// if(this.state.crtCd === '03' && this.state.printYn === 'N'){
					//   	const params = {
					//     	docId: this.state.docid,
					//     	fileId: this.state.fileId,
					//     	brno: this.state.brno,
					//   	}
					// 	this.state.getPrint(params)
						
					// 	document.getElementById('pdfIfrm').contentWindow.document.getElementById("print").click();
					// }else if(this.state.crtCd === '03' && this.state.printYn === 'Y'){
					//   this.state.error({ message: '해당 파일은 출력할수 없습니다.' })
					//   return
					// }else{
					// 	document.getElementById('pdfIfrm').contentWindow.document.getElementById("print").click();
					// }
					
					if(this.state.crtCd === '03'){
						const params = {
						  docId: this.state.docid,
						  fileId: this.state.fileId,
						  brno: this.state.brno,
						}
					  	this.state.getPrint(params)
					  
					  	document.getElementById('pdfIfrm').contentWindow.document.getElementById("print").click();
					}else{
						document.getElementById('pdfIfrm').contentWindow.document.getElementById("print").click();
					}
				  },
				},
			})	
		  }
		
		  /**
		   * 출력
		   */
		  const download = () => {	
			this.state.confirm({
				title: '확인',
				message: '증명서 내용에 이상이 없음을 확인한 뒤 다운로드 하시기 바랍니다.\n (다운로드 후에는 단순 오타·오기인 경우에도 별도 수정 발급 절차가 필요합니다.)',
				params: {
				  type: 'confirm',
				  callback: () => {
						if (isMobile) {
							console.log("this.state.crtCd", this.state.crtCd);
							if(this.state.crtCd === '03'){
							
								const url = this.state.showResponse;
								const link = document.createElement('a');
								link.href = url;
								link.setAttribute('download', this.state.fileNm);
								link.setAttribute('id', 'tempLink');
								document.body.appendChild(link);
								link.click();
								
									const params = {
										docId: this.state.docid,
										fileId: this.state.fileId,
										brno: this.state.brno,
									}
									this.state.getDown(params)
									console.log("params", params);
							}else{			    	
								const url = this.state.showResponse;
								const link = document.createElement('a');
								link.href = url;
								link.setAttribute('download', this.state.fileNm);
								link.setAttribute('id', 'tempLink');
								document.body.appendChild(link);
								link.click();
							}
							/*
							console.log("2");
							var url = this.state.showResponse;
							var outputFilePath = '/storage/emulated/0/Download/test/'+this.state.fileNm;
							window.M.execute('exWNFileDownload', url, outputFilePath,
								window.M.response.on( function( status, result ) {
									console.log(status);
									console.log(result);
									window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
								}).toString()
							);
							*/
						}else{	
							console.log("this.state.crtCd", this.state.crtCd);
							if(this.state.crtCd === '03'){
								document.getElementById('pdfdown').click();
								const params = {
									docId: this.state.docid,
									fileId: this.state.fileId,
									brno: this.state.brno,
								}
								this.state.getDown(params)
								console.log("params", params);
							}else{
								document.getElementById('pdfdown').click();
							}
						}
					},
				},
			})
		  }
		let style = {
		    backgroundColor: 'rgb(0, 0, 0)',
		    position: 'fixed',
		    inset: '0px',
		    opacity: '0.6',
		    zIndex: '11',
		}
		
		let styleModal = {
		    //position: 'absolute',
			position: 'fixed',
		    opacity: '1',
		    zIndex: '12',
		    display: 'block',
		}
		
		let styleDiv = {
		    height: '900px'
		}
		let styleADiv = {
		    display: 'none'
		}
		  return (
		    <React.Fragment>
		      <div style={style}></div>
		      <div style={styleModal} id="document-register" className="modal w1200">
		        <div className="modal-head">
		          <h2>디지털 증명 문서 열람</h2>
		        </div>
		        <div className="modal-cont" style={styleDiv} >
					<div className="pdf-header">
					<a href="#" className="btn-pdfdown" onClick={download}></a>
					{!isMobile ? (<a href="#" className="btn-print" onClick={print}></a>) : ( '')}
					</div>		
					<div style={styleADiv}>
							<a href={this.state.showResponse} id="pdfdown" className="btn-pdfdown" download={this.state.fileNm}>다운로드</a>
					</div>	
						<iframe id="pdfIfrm" ref={this.setContentRef} width='100%' height='100%' src={'/pdfViewer/viewer.html?file=' + this.state.showResponse}></iframe>
					{/* <object id="pdfIfrm"  frame-ancestors='https://*;' width='100%' height='100%' data={'/pdfViewer/viewer.html?file=' + this.state.showResponse} ></object> */}
		        	{/* <iframe id="pdfIfrm" ref={this.setContentRef} width='100%' height='100%' src={'https://wallet2.utradehub.or.kr/pdfViewer/viewer.html?file=' + this.state.showResponse}></iframe> */}
		        </div>
		        <button type="button" className="modal-close b-close" onClick={this.state.onClose}>
		          창닫기
		        </button>
		      </div>
			   
		    </React.Fragment>
		  )
	}		  
}

const mapStateToProps = (state) => {
  return {
    template: state.template,
  }
}

const actionCreators = {
  getPrint: certboxActions.getPrint,
  confirm : alertActions.confirm,
  getDown: certboxActions.getDown,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(PdfViewer)
